"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Div-like abstraction of Material's `Box`
 * 
 * Original author @heron-web/material (no longer maintained)
 */class Div extends _react.default.PureComponent {
  /**
   * Render.
   *
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: this.props.className,
      dangerouslySetInnerHTML: this.props.dangerouslySetInnerHTML,
      onBlur: this.props.onBlur,
      onClick: this.props.onClick,
      onContextMenu: this.props.onContextMenu,
      onFocus: this.props.onFocus,
      onScroll: this.props.onScroll,
      ref: this.props.innerRef,
      style: this.styles,
      tabIndex: this.props.tabIndex,
      title: this.props.title,
      ...this.boxProps,
      ...this.props.BoxProps,
      children: this.props.children
    });
  }

  /**
   * Get extra props to apply to our `Box`.
   *
   * (Used for styling props where the presence of others 
   * impacts the behaviour even if the value is `undefined`).
   * 
   * @return {Object}
   */
  get boxProps() {
    const props = {};
    if (this.props.ml !== undefined) props.ml = this.props.ml;
    if (this.props.mr !== undefined) props.mr = this.props.mr;
    if (this.props.mb !== undefined) props.mb = this.props.mb;
    if (this.props.mt !== undefined) props.mt = this.props.mt;
    if (this.props.mx !== undefined) props.mx = this.props.mx;
    if (this.props.my !== undefined) props.my = this.props.my;
    if (this.props.pl !== undefined) props.pl = this.props.pl;
    if (this.props.pr !== undefined) props.pr = this.props.pr;
    if (this.props.pb !== undefined) props.pb = this.props.pb;
    if (this.props.pt !== undefined) props.pt = this.props.pt;
    if (this.props.px !== undefined) props.px = this.props.px;
    if (this.props.py !== undefined) props.py = this.props.py;
    return props;
  }

  /**
   * Styles.
   *
   * @type {Object}
   */
  get styles() {
    return {
      display: !this.props.hidden ? this.props.display : "none",
      height: this.props.height,
      maxHeight: this.props.maxHeight,
      minHeight: this.props.minHeight,
      order: this.props.order,
      overflow: this.props.overflow,
      overflowX: this.props.overflowX,
      overflowY: this.props.overflowY,
      position: this.props.position,
      textAlign: this.props.textAlign || (this.props.centreText ? "center" : undefined),
      userSelect: this.props.selectable ? "text" : undefined,
      width: this.props.width,
      maxWidth: this.props.maxWidth,
      minWidth: this.props.minWidth,
      ...this.props.style
    };
  }
  static propTypes = {
    BoxProps: _propTypes.default.object,
    centreText: _propTypes.default.bool,
    className: _propTypes.default.string,
    display: _propTypes.default.string,
    height: _propTypes.default.string,
    hidden: _propTypes.default.bool,
    innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
      current: _propTypes.default.instanceOf(Element)
    })]),
    maxHeight: _propTypes.default.string,
    minHeight: _propTypes.default.string,
    order: _propTypes.default.number,
    overflow: _propTypes.default.string,
    overflowX: _propTypes.default.string,
    overflowY: _propTypes.default.string,
    position: _propTypes.default.string,
    ml: _propTypes.default.number,
    mr: _propTypes.default.number,
    mb: _propTypes.default.number,
    mt: _propTypes.default.number,
    mx: _propTypes.default.number,
    my: _propTypes.default.number,
    pl: _propTypes.default.number,
    pr: _propTypes.default.number,
    pb: _propTypes.default.number,
    pt: _propTypes.default.number,
    px: _propTypes.default.number,
    py: _propTypes.default.number,
    onBlur: _propTypes.default.func,
    onClick: _propTypes.default.func,
    onContextMenu: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    onScroll: _propTypes.default.func,
    selectable: _propTypes.default.bool,
    style: _propTypes.default.object,
    tabIndex: _propTypes.default.string,
    textAlign: _propTypes.default.string,
    title: _propTypes.default.string,
    width: _propTypes.default.string,
    maxWidth: _propTypes.default.string,
    minWidth: _propTypes.default.string
  };
  static defaultProps = {
    centreText: false,
    columnar: false,
    display: "block",
    hidden: false,
    gap: 1,
    selectable: false
  };
}
var _default = exports.default = Div;